/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Type } from "class-transformer";
import {
  IsArray,
  IsDefined,
  IsEnum,
  IsNotEmpty,
  IsObject,
  IsOptional,
  IsString,
  MaxLength,
  ValidateNested,
} from "class-validator";

import "reflect-metadata";

import { FieldTypeTarget } from "../../enums";
import type { IValidationParams, IValidationType } from "../../models";

export class FieldTypeAttributes {}

export class FieldTypeDto {
  id: number;

  @IsString()
  @IsNotEmpty()
  @MaxLength(6)
  @IsEnum(FieldTypeTarget)
  target: FieldTypeTarget;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  name: string;

  @IsString()
  @IsOptional()
  @MaxLength(255)
  description?: string;

  @IsDefined()
  @IsArray()
  @IsOptional()
  limitedTo?: string[];

  @IsDefined()
  @IsObject()
  @ValidateNested()
  @IsOptional()
  validationDefaults?: Record<IValidationType, IValidationParams>;

  @IsDefined()
  @IsObject()
  @ValidateNested()
  @IsOptional()
  @Type(() => FieldTypeAttributes)
  attributes?: FieldTypeAttributes;
}
